import moment from 'moment';

export const subtractDate = (arg) => {
  return moment().subtract(1, arg).format('YYYY-MM-DDTHH:MM');
};
